// extracted by mini-css-extract-plugin
export default {"hero":"CategoryLandingPage-hero-d3X","heroImage":"CategoryLandingPage-heroImage-pdL"};